// Generated by Melange


function make(enum_namesOpt, json_namesOpt, omit_default_valuesOpt, param) {
  const enum_names = enum_namesOpt !== undefined ? enum_namesOpt : true;
  const json_names = json_namesOpt !== undefined ? json_namesOpt : true;
  const omit_default_values = omit_default_valuesOpt !== undefined ? omit_default_valuesOpt : true;
  return {
          enum_names: enum_names,
          json_names: json_names,
          omit_default_values: omit_default_values
        };
}

const $$default = make(undefined, undefined, undefined, undefined);

function to_int(param) {
  return ((
            param.enum_names ? 4 : 0
          ) + (
            param.json_names ? 2 : 0
          ) | 0) + (
          param.omit_default_values ? 1 : 0
        ) | 0;
}

function of_int(n) {
  const b = function (v, n) {
    return (n & v) === v;
  };
  return {
          enum_names: b(4, n),
          json_names: b(2, n),
          omit_default_values: b(1, n)
        };
}

const max_int = to_int({
      enum_names: true,
      json_names: true,
      omit_default_values: true
    });

export {
  make ,
  $$default as default,
  to_int ,
  of_int ,
  max_int ,
}
/* default Not a pure module */
